<div class="container-fluid">
  <div class="loading-container">
    <div class="loading-content">
      
      <div class="loading-text">
        <h2 class="loading-title">{{ loadingMessage }}</h2>
        <p class="loading-subtitle">{{ loadingSubMessage }}</p>
      </div>
      <div class="loading-spinner" *ngIf="showSpinner">
        <img src="/assets/img/loading_logo.gif" alt="Loading" class="loading-logo logo-quote-loading">
      </div>
    </div>
  </div>
</div>
